import React, { Component } from "react";
import { connect } from "react-redux";
import { Drawer } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "react-router-dom";
import Radio from "@material-ui/core/Radio";
import { withStyles } from "@material-ui/core/styles";
import instance from "../../../store/actions/instance";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { withRouter } from "react-router-dom";
import {
  fetchBranch,
  setBranchDeliveryCharge,
  updateMOV,
} from "../../../store/actions";
import ChangeDeliveryTypeDialog from "../SecondStep/ChangeDeliveryTypeDialog";
import { CircularProgress } from "@material-ui/core";
import { fetchDeliveryCharges } from "../../../store/actions/store";

const ColoredRadio = withStyles({
  root: {
    color: "#0099cc",
    "&$checked": {
      color: "#0099cc",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

class Addresses extends Component {
  state = {
    selectedAddress: this.props.addresses.find((a) => a.is_preferred)?.id,
    dialogOpen: false,
    tempSelectedAddress: null,
    selectLoading: false,
    fetchingDeliveryCharges: false,
  };

  componentDidMount = async () => {
    if (!this.props.fetchedDeliveryCharges) {
      this.setState({ fetchDeliveryCharges: true });
      await this.props.fetchDeliveryCharges(this.props.country_code);
      this.setState({ fetchDeliveryCharges: false });
    }
  };
  componentDidUpdate = () => {
    const preferredAddressID = this.props.addresses.find(
      (a) => a.is_preferred
    )?.id;
    if (
      preferredAddressID &&
      preferredAddressID !== this.state.selectedAddress
    ) {
      this.setState({ selectedAddress: preferredAddressID });
    }
  };
  renderAddressDetails = (address) => {
    const { language } = this.props;
    const translations = {
      Building: language == "english" ? "Building" : "مبنى",
      avenue: language == "english" ? "avenue" : "جادة",
      apartment: language == "english" ? "apartment" : "شقة",
      paci: language == "english" ? "paci" : "الرقم الآلي",
      additional: language == "english" ? "additional" : "اضافي",
      floor: language == "english" ? "floor" : "الدور",
    };
    let tmp = `${translations["Building"]} ${address.building}`;
    if (address.avenue) tmp += `, ${translations["avenue"]} ${address.avenue}`;
    if (address.floor) tmp += `, ${translations["floor"]} ${address.floor}`;
    if (address.apartment)
      tmp += `, ${translations["apartment"]} ${address.apartment}`;
    if (address.location_id)
      tmp += `, ${translations["paci"]} ${address.location_id}`;
    if (address.additional)
      tmp += `, ${translations["additional"]}: ${address.additional}`;
    return tmp;
  };
  renderAddressTitle = (address) => {
    const { language, settings } = this.props;
    let branchName = "";
    if (
      settings.is_branch_based_ordering &&
      address.branch_delivery_charge__branch__name
    ) {
      branchName =
        language == "english"
          ? ` (from ${address.branch_delivery_charge__branch__name} branch)`
          : ` (من فرع ${address.branch_delivery_charge__branch__ar_name})`;
    }
    return `${
      language == "english" ? address["area__name"] : address.area__ar_name
    }, ${
      language == "english"
        ? address.country__name === "Qatar"
          ? "Zone"
          : "Block"
        : address.country__name === "Qatar"
        ? "منطقة"
        : address.country__name === "Bahrain"
        ? "مجمع"
        : "قطعة"
    } ${address.country__name === "Qatar" ? address.zone : address["block"]}, ${
      language == "english" ? "St." : "شارع"
    } ${address["street"]}${branchName}`;
  };
  onChangeAddress = (id) => {
    this.setState({ selectedAddress: id });
    this.makeAddressPreferred(id);
  };

  makeAddressPreferred = async (id) => {
    try {
      const res = await instance.post("make_address_preferred/", {
        address_id: id,
      });
      if (res.data.success) {
        this.props.makeAddressPreferred(id);
        let tempAddress = this.props.addresses.find((a) => a.id === id);
        this.props.switchAddress(
          tempAddress,
          this.props.settings.is_branch_based_ordering
        );
        if (this.props.settings.is_branch_based_ordering) {
          this.props.updateBranch(tempAddress);
        }
        if (this.props.extraAction) this.props.extraAction();
        this.props.onClose();
      }
    } catch (e) {
      console.error(e);
    }
  };
  deleteAddress = async (adrs) => {
    try {
      const res = await instance.post("delete_address/", {
        address_id: adrs.id,
      });
      if (res.data.success) {
        this.props.deleteAddress(adrs.id, res.data.new_preferred);
        if (adrs.is_preferred || this.props.addresses.length == 0) {
          this.setState({ selectedAddress: res.data.new_preferred });
          if (this.props.settings.is_branch_based_ordering) {
            const newPreferredAddressIsFromTheSameBranch =
              this.props.addresses.find(
                (adr) => adr.id === res.data.new_preferred
              )?.branch_delivery_charge__branch__id ===
              adrs.branch_delivery_charge__branch__id;
            if (
              !this.props.addresses.length ||
              !newPreferredAddressIsFromTheSameBranch
            ) {
              if (!newPreferredAddressIsFromTheSameBranch) {
                this.props.updateBranch(
                  this.props.addresses.find(
                    (adr) => adr.id === res.data.new_preferred
                  )
                );
              } else this.props.clearBranch();
              this.props.updateCustomer({
                addresses: [], // This will clear the current customer address
                deletingAddress: true,
              });
              this.props.useDispatch("CLEAR_STORE"); // Start the loading screen so that it transitions smoothly
              window.setTimeout(() => window.location.reload(), 100);
            } else {
              this.props.updateBranch(
                this.props.addresses.find(
                  (adr) => adr.id === res.data.new_preferred
                )
              );
              this.props.updateCustomer({
                addresses: this.props.addresses,
                deletingAddress: true,
              });
            }

            this.props.updateMOV(
              this.props.branchDeliveryCharges.find(
                (bd) =>
                  bd.id ==
                  this.props.addresses.find(
                    (adr) => adr.id === res.data.new_preferred
                  )?.branch_delivery_charge_id
              )?.minimum_order_value || 0
            );
          } else
            this.props.updateCustomer({
              addresses: this.props.addresses,
              deletingAddress: true,
            });
        }
      }
    } catch (e) {
      console.error(e);
    }
  };
  areaIsActive = (adrs) => {
    const { settings } = this.props;
    if (
      !(
        (settings.enable_delivery || settings.enable_delivery_select) &&
        !this.props.cart.pickup_only_items
      )
    )
      return false;

    if (settings.is_branch_based_ordering) {
      return (
        adrs.area__is_deleted == false &&
        adrs.area__delivery_charge__is_active &&
        adrs.area__delivery_charge__is_deleted == false &&
        adrs.branch_delivery_charge__is_active &&
        adrs.branch_delivery_charge__is_deleted == false &&
        adrs.branch_delivery_charge__branch__is_deleted == false
      );
    }
    return (
      adrs.area__is_deleted == false &&
      adrs.area__delivery_charge__is_active &&
      adrs.area__delivery_charge__is_deleted == false
    );
  };

  clearCartAndChangeBranch = (adrsID) => {
    const { addresses } = this.props;
    const selectedAddress = addresses.find((adrs) => adrs.id === adrsID);
    if (!selectedAddress) return;
    this.props.branch.loading = true;
    this.props.fetchBranch(
      "delivery",
      selectedAddress.branch_delivery_charge_id,
      this.props.cart.cart,
      this.props.applied_promo,
      this.props.history,
      null,
      null,
      selectedAddress.branch_delivery_charge__branch__id
    );
    this.props.setBranchDeliveryCharge({
      bdc: selectedAddress.branch_delivery_charge_id,
      branch: selectedAddress.branch_delivery_charge__branch__id,
      isPickup: false,
    });
  };

  onClickAddress = (adrs) => {
    const { settings, branch } = this.props;
    const BDC = this.props.branchDeliveryCharges;
    let totalCartLength =
      this.props.cart.cart.length + this.props.promo_items.length;

    if (this.areaIsActive(adrs)) {
      if (!settings.is_branch_based_ordering) this.onChangeAddress(adrs.id);
      else {
        if (
          branch.branch !== adrs.branch_delivery_charge__branch__id &&
          branch.branch != null &&
          totalCartLength > 0
        ) {
          this.setState({
            tempSelectedAddress: adrs.id,
            dialogOpen: true,
          });
        } else if (branch.branch === adrs.branch_delivery_charge__branch__id) {
          this.setState({ selectLoading: true });

          this.props.updateMOV(
            BDC.find((bd) => bd.id == adrs.branch_delivery_charge_id)
              .minimum_order_value || 0
          );
          this.onChangeAddress(adrs.id);
        } else {
          this.onChangeAddress(adrs.id);
          this.clearCartAndChangeBranch(adrs.id);
        }
      }
    }
  };

  render() {
    const { language, open, settings, branch, themeColor, areas } = this.props;
    const { fetchDeliveryCharges } = this.state;
    const BDC = this.props.branchDeliveryCharges;
    let { addresses } = this.props;
    let totalCartLength =
      this.props.cart.cart.length + this.props.promo_items.length;
    if (this.props.comingFrom == "branchSelect" && this.props.bdcID) {
      if (settings.is_branch_based_ordering) {
        let tempBDC = BDC.find((bdc) => bdc.id === this.props.bdcID);
        if (tempBDC) {
          addresses = addresses.filter(
            (adrs) =>
              adrs.area__name === tempBDC.area ||
              adrs.area__ar_name === tempBDC.ar_area
          );
        }
      } else {
        let tempArea = areas.find((a) => a.id === this.props.bdcID);
        if (tempArea) {
          addresses = addresses.filter(
            (adrs) =>
              adrs.area__name === tempArea.name ||
              adrs.area__ar_name === tempArea.ar_name
          );
        }
      }
    }

    return (
      <Drawer
        anchor="bottom"
        classes={{
          paperAnchorBottom: language == "arabic" ? "left-auto" : "",
        }}
        open={open}
        onClose={() => this.props.onClose()}
        PaperProps={{
          style: {
            minHeight: 100,
            height: "auto",
            width: "100%",
          },
          className: "text-center",
        }}
        onBackdropClick={() => this.props.onClose()}
      >
        {settings.is_branch_based_ordering && this.state.dialogOpen && (
          <ChangeDeliveryTypeDialog
            yes={() => {
              this.clearCartAndChangeBranch(this.state.tempSelectedAddress);
              this.onChangeAddress(this.state.tempSelectedAddress);
            }}
            dialogOpen={this.state.dialogOpen}
            onClose={() => {
              this.setState({ dialogOpen: false });
            }}
          />
        )}
        <div style={{ backgroundColor: "white" }}>
          {fetchDeliveryCharges ? (
            <CircularProgress
              color="primary"
              style={{ marginTop: 30, marginBottom: 30 }}
            />
          ) : (
            <>
              <h2
                className={"mx-auto ".concat(
                  addresses.length
                    ? language == "english"
                      ? "text-left"
                      : "text-right"
                    : "text-center"
                )}
                style={{
                  width: "90%",
                  marginTop: 25,
                  fontFamily: language == "english" ? "Quicksand" : "Cairo",
                  fontSize: 16,
                }}
              >
                {addresses.length ? (
                  <>
                    {language == "english"
                      ? "Delivery address"
                      : "عنوان التوصيل"}
                  </>
                ) : (
                  (settings.enable_delivery ||
                    settings.enable_delivery_select) && (
                    <>
                      {language == "english"
                        ? "You don't have saved addresses"
                        : "ليس لديك عناوين محفوظة!"}
                    </>
                  )
                )}
              </h2>
              {!(
                settings.enable_delivery || settings.enable_delivery_select
              ) && (
                <p
                  className="bold"
                  style={{
                    color: "red",
                    paddingLeft: language == "english" && 16,
                    paddingRight: language == "arabic" && 16,

                    marginBottom: 10,
                  }}
                >
                  {language == "english"
                    ? "Sorry. We're not delivering at the moment"
                    : "عذرا. لا نقوم بالتوصيل حاليا"}
                </p>
              )}
              {!!addresses.length &&
                (settings.enable_delivery ||
                  settings.enable_delivery_select) && (
                  <List dense style={{ backgroundColor: "white" }}>
                    {addresses.map((adrs) => {
                      const labelId = `checkbox-list-secondary-label-${adrs.id}`;
                      return (
                        <div
                          style={{
                            direction: language == "english" ? "ltr" : "rtl",
                          }}
                        >
                          {!this.areaIsActive(adrs) && (
                            <p
                              className="bold"
                              style={{
                                color: "red",
                                paddingLeft: language == "english" && 16,
                                paddingRight: language == "arabic" && 16,
                                textAlign:
                                  language == "english" ? "left" : "right",
                                position: "relative",
                                top: 8,
                                marginBottom: 0,
                              }}
                            >
                              {language == "english"
                                ? "Not available"
                                : "غير متاح"}
                            </p>
                          )}
                          <ListItem
                            key={adrs.id}
                            button
                            onClick={() => {
                              this.onClickAddress(adrs);
                            }}
                            disabled={!this.areaIsActive(adrs)}
                            style={{
                              paddingRight: language == "english" ? 48 : 16,
                              paddingLeft: language == "english" ? 16 : 48,
                            }}
                          >
                            <ListItemText
                              id={labelId}
                              primary={
                                <>
                                  <span className="bold">
                                    {this.renderAddressTitle(adrs)}
                                  </span>
                                </>
                              }
                              secondary={
                                <div style={{ paddingRight: 10 }}>
                                  <p className="bold m-0">
                                    {this.renderAddressDetails(adrs)}
                                  </p>
                                </div>
                              }
                              style={{
                                minHeight: 40,
                                maxWidth: "93%",
                                textAlign:
                                  language == "english" ? "left" : "right",
                              }}
                            />
                            <ListItemSecondaryAction
                              style={{
                                left: language == "arabic" ? 16 : "unset",
                                right: language == "english" ? 16 : "unset",
                              }}
                            >
                              <ColoredRadio
                                checked={
                                  this.state.selectedAddress == adrs.id &&
                                  this.areaIsActive(adrs) &&
                                  this.props.customerAddress
                                    ?.selectedDeliveryType !== 1 &&
                                  (!settings.is_branch_based_ordering ||
                                    (settings.is_branch_based_ordering &&
                                      adrs.branch_delivery_charge_id ===
                                        branch.bdc))
                                }
                                onChange={() => {
                                  this.onClickAddress(adrs);
                                }}
                                disabled={!this.areaIsActive(adrs)}
                              />
                              <DeleteOutlineIcon
                                style={{
                                  color: "#ff0000cc",
                                  marginLeft: language == "english" && 5,
                                  marginRight: language == "arabic" && 5,
                                  cursor: "pointer",
                                }}
                                onClick={() => this.deleteAddress(adrs)}
                              />
                            </ListItemSecondaryAction>
                          </ListItem>
                        </div>
                      );
                    })}
                  </List>
                )}

              {!!this.props.cart.cart.length &&
                (settings.enable_delivery || settings.enable_delivery_select) &&
                this.props.comingFrom !== "profile" && (
                  <Link
                    to={{
                      pathname:
                        this.props.comingFrom === "branchSelect"
                          ? "/checkout/address"
                          : "/select/branch",
                      state: {
                        prevPath: this.props.history.location.pathname,
                        newAddress: true,
                      },
                      //state: { prevPath: window.location.pathname },
                    }}
                    onClick={() => {
                      if (this.props.onAddNewAddress)
                        this.props.onAddNewAddress();
                      this.props.onClose();
                    }}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      style={{
                        width: "97%",
                        marginBottom: 8,
                        marginTop: 10,
                        fontSize: "1rem",
                        boxShadow: "none",
                        textTransform: "none",
                      }}
                      dir={language == "english" ? "ltr" : "rtl"}
                      endIcon={language == "english" && <AddIcon />}
                      startIcon={
                        language == "arabic" && <AddIcon className="ml-2" />
                      }
                    >
                      {language == "english"
                        ? "Add a new address"
                        : "اضافة عنوان جديد"}
                    </Button>
                  </Link>
                )}

              <Button
                variant="contained"
                color="primary"
                onClick={() => this.props.onClose()}
                style={{
                  width: "97%",
                  marginBottom: 8,
                  height: 45,
                  fontSize: "1rem",
                  marginTop: 15,
                  boxShadow: "none",
                  textTransform: "none",
                }}
                dir={language == "english" ? "ltr" : "rtl"}
              >
                {this.state.selectLoading ? (
                  <CircularProgress
                    style={{ width: 30, height: 30, color: "white" }}
                  />
                ) : (
                  <>
                    {this.props.backText ||
                      (language == "english" ? "Back" : "الرجوع")}
                  </>
                )}
              </Button>
            </>
          )}
        </div>
      </Drawer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,

    settings: state.store.store.settings,
    addresses: state.auth.addresses,
    cart: state.cart,
    branch: state.branch,
    applied_promo: state.cart.promos,
    branchDeliveryCharges: state.store.store.branch_delivery_charges,
    promo_items: state.cart.promo_items,
    customerAddress: state.customers.address,
    themeColor: state.store.store.settings.dark || "#0099cc",
    areas: state.store.store.areas,
    country_code: state.store.store.country_code,
    fetchedDeliveryCharges: state.store.fetchedDeliveryCharges,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    switchAddress: (adrs, isBranchBased) =>
      dispatch({
        type: "SWITCH_ADDRESS",
        payload: { address: adrs, isBranchBased: isBranchBased },
      }),
    makeAddressPreferred: (id) =>
      dispatch({ type: "MAKE_ADDRESS_PREFERRED", payload: id }),
    updateCustomer: (data) =>
      dispatch({ type: "UPDATE_CUSTOMER", payload: data }),
    deleteAddress: (id, new_preferred) =>
      dispatch({ type: "DELETE_ADDRESS", payload: { id, new_preferred } }),
    updateBranch: (adrs) => dispatch({ type: "UPDATE_BRANCH", payload: adrs }),
    fetchBranch: (
      type,
      bdc_id,
      cart,
      promo,
      history,
      forceCurrency,
      QRValid,
      branchID
    ) =>
      dispatch(
        fetchBranch(type, bdc_id, cart, promo, history, null, null, branchID)
      ),
    setBranchDeliveryCharge: (bdc_obj) =>
      dispatch(setBranchDeliveryCharge(bdc_obj)),
    updateMOV: (mov) => dispatch(updateMOV(mov)),
    clearBranch: () => dispatch({ type: "CLEAR_BRANCH" }),
    useDispatch: (type) => dispatch({ type: type }),
    fetchDeliveryCharges: (countryCode) =>
      dispatch(fetchDeliveryCharges(countryCode)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Addresses)
);
